module.exports = __webpack_public_path__ + "media/images/city_img/b_2-38a6a97c6b15c2a8fdbeb89866099748.jpg";